import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import { contactReligionDetailSchema } from '../ValidationSchema';
import { addContactReligionDetails, getCast, getCity, getCountry, getDomain, getReligion, getState } from '../../asiosConfig';

function ContactReligionForm() {
    const [countryList, setCountryList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [religionList, setReligionList] = useState([]);
    const [castList, setCastList] = useState([]);
    const [domainList, setDomainList] = useState([]);

    const indiaId = 233;
    const navigate = useNavigate();

    const initialValues = {
        streetAddress: '',
        pincode: '',
        area: '',
        city: '',
        state: '',
        country: indiaId,
        caste: '',
        religion: '',
        citizenship: indiaId,
        domain: '',
        specialmobileNumber: '',
        // tokan: localStorage.getItem('token'),
        user_id: localStorage.getItem('user'),
    };
    
    useEffect(() => {
        const fetchCountry = async () => {
            try {
                const response = await getCountry();
                setCountryList(response.data.data);
            } catch (error) {
                console.error('Error fetching Country:', error);
            }
        };

        const fetchDomain = async () => {
            try {
                const response = await getDomain();
                setDomainList(response.data.data);
            } catch (error) {
                console.error('Error fetching Domain:', error);
            }
        };

        fetchDomain();
        fetchCountry();
    }, []);

    useEffect(() => {
        if (initialValues.country) {
            fetchState(initialValues.country);
        }
    }, [initialValues.country]);

    useEffect(() => {
        if (initialValues.state) {
            fetchCity(initialValues.state);
        }
    }, [initialValues.state]);

    const fetchState = async (country_id) => {
        try {
            const response = await getState(country_id);
            setStateList(response.data.data);
        } catch (error) {
            console.error('Error fetching State:', error);
        }
    };

    const fetchCity = async (state_id) => {
        try {
            const response = await getCity(state_id);
            setCityList(response.data.data);
        } catch (error) {
            console.error('Error fetching City:', error);
        }
    };

    const fetchReligion = async (Domain_id) => {
        try {
            const response = await getReligion({ Domain_id });
            setReligionList(response.data.data);
        } catch (error) {
            console.error('Error fetching Religion:', error);
        }
    };

    const fetchCast = async (religion_id) => {
        try {
            const response = await getCast(religion_id);
            setCastList(response.data.data);
        } catch (error) {
            console.error('Error fetching Cast:', error);
        }
    };

    const handleCountryChange = (event, setFieldValue) => {
        const country_id = event.target.value;
        setFieldValue('country', country_id);
        setFieldValue('state', '');
        setFieldValue('city', '');
        fetchState(country_id);
    };

    const handleStateChange = (event, setFieldValue) => {
        const state_id = event.target.value;
        setFieldValue('state', state_id);
        setFieldValue('city', '');
        fetchCity(state_id);
    };

    const handleDomainChange = (event, setFieldValue) => {
        const Domain_id = event.target.value;
        setFieldValue('domain', Domain_id);
        setFieldValue('religion', '');
        setFieldValue('caste', '');
        fetchReligion(Domain_id);
    };

    const handleReligionChange = (event, setFieldValue) => {
        const religion_id = event.target.value;
        setFieldValue('religion', religion_id);
        setFieldValue('caste', '');
        fetchCast(religion_id);
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const response = await addContactReligionDetails(values);
            if (response.status === 200 || response.status === 201) {
                toast.success(response.data.message);
                localStorage.setItem('last_complete_step', response.data.last_complete_step);
                navigate('/lifeStyle');
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error(error.response?.data?.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className='siteForm flex-grow-1'>
            <div className="container">
                <div className="row justify-content-center align-items-center">
                    <div className="col-md-5">
                        <div className="formTitle">
                            <h3> Religion & Contact Details</h3>
                        </div>
                        <Formik
                            initialValues={initialValues}
                            validationSchema={contactReligionDetailSchema}
                            onSubmit={handleSubmit}
                        >
                            {({ isSubmitting, setFieldValue }) => (
                                <Form className='mt-4'>
                                    <div className="mb-3">
                                        <label className='form-label'>Domain</label>
                                        <Field as="select" name="domain" className="form-select" onChange={(e) => handleDomainChange(e, setFieldValue)}>
                                            <option value="">Select Domain</option>
                                            {domainList.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.domain}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="domain" component="div" className='text-danger' />
                                    </div>
                                    
                                    <div className="mb-3">
                                        <label className='form-label'>Religion</label>
                                        <Field as="select" name="religion" className="form-select" onChange={(e) => handleReligionChange(e, setFieldValue)}>
                                            <option value="">Select Religion</option>
                                            {religionList.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.religion}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="religion" component="div" className='text-danger' />
                                    </div>

                                    <div className="mb-3">
                                        <label className='form-label'>Caste</label>
                                        <Field as="select" name="caste" className="form-select">
                                            <option value="">Select Caste</option>
                                            {castList.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.caste}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="caste" component="div" className='text-danger' />
                                    </div>

                                    <div className="mb-3">
                                        <label className='form-label'>Country</label>
                                        <Field as="select" name="country" className="form-select" onChange={(e) => handleCountryChange(e, setFieldValue)}>
                                            <option value="">Select Country</option>
                                            {countryList.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.country}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="country" component="div" className='text-danger' />
                                    </div>

                                    <div className="mb-3">
                                        <label className='form-label'>State</label>
                                        <Field as="select" name="state" className="form-select" onChange={(e) => handleStateChange(e, setFieldValue)}>
                                            <option value="">Select State</option>
                                            {stateList.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.state}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="state" component="div" className='text-danger' />
                                    </div>

                                    <div className="mb-3">
                                        <label className='form-label'>City</label>
                                        <Field as="select" name="city" className="form-select">
                                            <option value="">Select City</option>
                                            {cityList.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.city}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="city" component="div" className='text-danger' />
                                    </div>

                                    <div className="mb-3">
                                        <label className='form-label'>Street Address</label>
                                        <Field name="streetAddress" className="form-control" />
                                        <ErrorMessage name="streetAddress" component="div" className='text-danger' />
                                    </div>

                                    <div className="mb-3">
                                        <label className='form-label'>Area</label>
                                        <Field name="area" className="form-control" />
                                        <ErrorMessage name="area" component="div" className='text-danger' />
                                    </div>

                                    <div className="mb-3">
                                        <label className='form-label'>Pincode</label>
                                        <Field name="pincode" className="form-control" />
                                        <ErrorMessage name="pincode" component="div" className='text-danger' />
                                    </div>

                                    <div className="mb-3">
                                        <label className='form-label'>Citizenship</label>
                                        <Field as="select" name="citizenship" className="form-select">
                                            <option value="">Select Citizenship</option>
                                            {countryList.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.country}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="citizenship" component="div" className='text-danger' />
                                    </div>

                                    <div className="mb-3">
                                        <label className='form-label'>Alternate Mobile Number</label>
                                        <Field name="specialmobileNumber" className="form-control" />
                                        <ErrorMessage name="specialmobileNumber" component="div" className='text-danger' />
                                    </div>
                                            
                                    <div className="mb-3">
                                        <button type="submit" className="btn btn-primary formBtn" disabled={isSubmitting}>
                                            {isSubmitting ? 'Submitting...' : 'Save & Continue'}
                                        </button>
                                    </div>
                                    <br />
                                    <br />
                                </Form>
                            )}
                        </Formik>
                        <ToastContainer />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactReligionForm;
